import React from 'react';
import LastLesson from '../recap/LastLesson';
import CarryForward from '../notes/CarryForward';
import FamilyQuestions from '../notes/FamilyQuestions';
import './ArriveGroup.css';

/**
 * "Arrive" (pass 3 C1, 2026-09-28): everything a teacher reads BEFORE starting,
 * in one labelled group: Last lesson, Carry-forward, From home. It is the top
 * of the notes column at every width (pass 4 P4.3, 2026-10-04: the rail it
 * used to share is now the Private file), mounted once.
 *
 * From home used to sit ABOVE the tab row in the notes column only, so on a
 * desktop it was the one piece of arrival context outside the rail (C2). Its
 * data now comes from the page (useFamilyQuestions) for the same reason
 * Carry-forward's does: two mounts, one list. It renders nothing when the
 * family asked nothing, and its load-error line travels with it.
 *
 * Also carries the Carry-forward deliver error (C4, a note that is not on the
 * board is written directly), with Dismiss, leading with the owner's ask.
 */
const ArriveGroup = ({
	previousRecaps = null,
	onOpenPreviousRecaps = null,
	carryForward = null,
	carryOpen = true,
	onToggleCarry = null,
	onCarryAct = null,
	carryError = '',
	onDismissCarryError = null,
	currentTeacherId = null,
	familyQuestions = null,
}) => (
	<section className="ld-arrive" aria-labelledby="ld-arrive-title">
		<h3 className="ld-arrive__eyebrow" id="ld-arrive-title">
			Arrive
		</h3>
		<LastLesson previous={previousRecaps} onOpen={onOpenPreviousRecaps} />
		<CarryForward
			groups={carryForward?.groups || []}
			totalOpen={carryForward?.totalOpen || 0}
			isLoading={Boolean(carryForward?.isLoading)}
			open={carryOpen}
			onToggle={onToggleCarry}
			currentTeacherId={currentTeacherId}
			onAct={onCarryAct}
		/>
		{carryError && (
			<div className="ld-dismissable-error" role="alert">
				<p className="ld-arrive__error">
					That note did not save. Please tell Anthony right away.
					<span className="ld-arrive__detail">{carryError}</span>
				</p>
				{onDismissCarryError && (
					<button type="button" className="ld-dismiss" onClick={onDismissCarryError}>
						Dismiss
					</button>
				)}
			</div>
		)}
		{familyQuestions && (
			<FamilyQuestions
				questions={familyQuestions.questions}
				error={familyQuestions.error}
				resolving={familyQuestions.resolving}
				onAnswered={familyQuestions.markAnswered}
			/>
		)}
	</section>
);

export default ArriveGroup;
